import { useState } from 'react';
import { Flex, Text } from '../2022-component-library';
import styled from '@emotion/styled';
import { useMediaQuery } from '../helpers/useMediaQuery';

const StyledCheckbox = styled.input`
  cursor: pointer;
  margin-right: 0.5rem;
`;

const CalibrationPrompt = () => {
  const tinyScreen = useMediaQuery('(max-width: 800px)');
  const smallScreen = useMediaQuery('(max-width: 1050px)');
  const [brightnessChecked, setBrightnessChecked] = useState(false);
  const [fullscreenChecked, setFullscreenChecked] = useState(false);
  return (
    <Flex
      column
      centered
      boxShadow='0px 0px 6px rgba(0, 0, 0, 0.26)'
      borderRadius='12px'
      padding='0.75rem'
      margin={tinyScreen ? '0.5rem' : smallScreen ? '0.75rem' : '1.75rem'}
      minWidth='75%'
      minHeight='50px'
    >
      <fieldset>
        <Flex width='100%' marginBottom='0.75rem' marginLeft='1.5rem'>
          <Text fontWeight='bold' textDecoration='underline'>{`PLEASE ENSURE PATIENT HAS:`}</Text>
        </Flex>
        <div>
          <StyledCheckbox
            type='checkbox'
            id='brightness'
            name='brightness'
            checked={brightnessChecked}
            onChange={() => setBrightnessChecked(!brightnessChecked)}
          />
          <label htmlFor='brightness'>{`Set full brightness on their device`}</label>
        </div>
        <div>
          <StyledCheckbox
            type='checkbox'
            id='fullscreen'
            name='fullscreen'
            checked={fullscreenChecked}
            onChange={() => setFullscreenChecked(!fullscreenChecked)}
          />
          <label htmlFor='fullscreen'>{`Clicked the "ENTER FULL SCREEN" button on their left`}</label>
        </div>
      </fieldset>
    </Flex>
  );
};

export default CalibrationPrompt;
